import { render, staticRenderFns } from "./ChooseChannel.vue?vue&type=template&id=35c4646c&scoped=true&"
import script from "./ChooseChannel.vue?vue&type=script&lang=ts&"
export * from "./ChooseChannel.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseChannel.vue?vue&type=style&index=0&id=35c4646c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c4646c",
  null
  
)

export default component.exports